//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/GeometricAnalysis.js";
import "../no/Builder.js";
import "../no/ScCollector.js";
import "../no/Section.js";
import "../no/Expression.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/Section.js";
let d=[[[1,"BasePanelFaces",0,"ScCollector",0],[1,"BasePanelInnerContactCurves",0,"Section",0],[1,"BasePanelOuterContactCurves",0,"Section",0],[0,"BasePanelType",1,0],[0,"CrossSectionCurveOption",1,0],[1,"CrossSectionCurves",0,"Section",0],[0,"EvaluationMode",1,0],[0,"EvaluationPoint",1,"Point",0],[0,"EvaluationType",1,0],[0,"IsNegativeToleranceLabelDisplayed",1,0],[0,"IsNominalLabelDisplayed",1,0],[0,"IsPositiveToleranceLabelDisplayed",1,0],[0,"LabelDisplayOption",1,0],[0,"NegativeFlushnessTolerance",1,0],[0,"NegativeGapTolerance",1,0],[0,"NominalFlushness",1,0],[0,"NominalGap",1,0],[0,"PositiveFlushnessTolerance",1,0],[0,"PositiveGapTolerance",1,0],[0,"PreviewOption",1,0],[1,"SampleDistance",0,"Expression",0],[0,"SampleNumber",1,0],[1,"SecondPanelFaces",0,"ScCollector",0],[1,"SecondPanelInnerContactCurves",0,"Section",0],[1,"SecondPanelOuterContactCurves",0,"Section",0],[0,"SecondPanelType",1,0],[0,"SectionAlignment",1,0],[0,"SectionAlignmentDirection",1,"Direction",0],[0,"ShowOutRangeLabels",1,0]],[],[]];
SPLM.GeometricAnalysis.GapFlushnessBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.GeometricAnalysis.GapFlushnessBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.GeometricAnalysis.GapFlushnessBuilder.EvaluationTypes = Object.freeze({
    "Absolute" : "Absolute", "Visual" : "Visual"});

SPLM.GeometricAnalysis.GapFlushnessBuilder.EvaluationModes = Object.freeze({
    "Point" : "Point", "CurveNumber" : "CurveNumber", "Curve" : "Curve"});

SPLM.GeometricAnalysis.GapFlushnessBuilder.SectionAlignments = Object.freeze({
    "Curve" : "Curve", "CurveView" : "CurveView", "SpecifiedDirection" : "SpecifiedDirection"});

SPLM.GeometricAnalysis.GapFlushnessBuilder.DisplayOptions = Object.freeze({
    "GapOnly" : "GapOnly", "FlushnessOnly" : "FlushnessOnly", "Both" : "Both"});

SPLM.GeometricAnalysis.GapFlushnessBuilder.SectionCurveOptions = Object.freeze({
    "ContactCurve" : "ContactCurve", "UserDefined" : "UserDefined"});

SPLM.GeometricAnalysis.GapFlushnessBuilder.PanelTypes = Object.freeze({
    "Hem" : "Hem", "Flange" : "Flange", "Wall" : "Wall"});

export default SPLM;